import { Button, Menu, MenuItem } from "@material-ui/core";
import { MoreVertRounded, Visibility, VisibilityOff } from "@material-ui/icons";
import React, { MouseEvent, useRef, useState } from "react";
import { useStyles } from "./styles";

interface VerticalActionMenuProps {
  companyIsHidden: boolean;
  handleHiddenStateChange: (actionType: "HIDE" | "UN_HIDE") => void;
}

export const VerticalActionMenu = (props: VerticalActionMenuProps) => {
  const { companyIsHidden, handleHiddenStateChange } = props;
  const styles = useStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleOpen = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (actionType?: "HIDE" | "UN_HIDE" | null) => {
    setAnchorEl(null);
    if (!actionType) return;
    handleHiddenStateChange(actionType);
  };

  return (
    <>
      <Button
        aria-controls="customized-menu"
        aria-haspopup="true"
        variant="text"
        color="primary"
        endIcon={<MoreVertRounded />}
        onClick={handleOpen}
      >
        ACTIONS
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => handleClose()}
        classes={{
          paper: styles.paper,
          list: styles.list,
        }}
      >
        {!companyIsHidden && (
          <MenuItem onClick={() => handleClose("HIDE")}>
            <VisibilityOff /> Hide Company
          </MenuItem>
        )}
        {companyIsHidden && (
          <MenuItem onClick={() => handleClose("UN_HIDE")}>
            <Visibility /> Unhide Company
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
